import { call, put, takeEvery } from "redux-saga/effects";
import { gioiTinhApi } from "../../../api/category/gioiTinhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eDmGioiTinhActionIds } from "../../action-types/category/IDmGioiTinhActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.gioiTinh;

export function* gioiTinhSaga(): any {
  yield takeEvery(eDmGioiTinhActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(gioiTinhApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
